import React, { useEffect, useState } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import useManageCompanyOrder from './useManageCompanyOrder';
import { formatAmount } from '../../../utils/formatAmount';

const CompanyOrderDetail = ({order}) => {

  const { getCompanyOrderDetailByOrder } = useManageCompanyOrder()

  const [orderDetails, setOrderDetails] = useState([])


  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await getCompanyOrderDetailByOrder({orderId: order.id});
        console.log(response)
        setOrderDetails(response);
      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    };
  
    if (order) {
      fetchOrderDetails();
    }
    
  }, [order]);

  const totalQty = orderDetails.reduce((sum, order) => sum + order.qty, 0);
  const totalAmount = orderDetails.reduce((sum, order) => sum + order.skuTotalAmount, 0);

  return (
    <div>
      <h3 className='text-3xl'>Company Order Detail</h3>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: '#96baf2' }}>
            <TableCell>No.</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Qty</TableCell>
            <TableCell>SKU Total Amount</TableCell>
            <TableCell>Unit Price</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orderDetails.map((order, index) => (
            <TableRow key={index}>
              <TableCell>{index+1}</TableCell>
              <TableCell>{order.CompanySku && order.CompanySku.productName}</TableCell>
              <TableCell>{order.qty}</TableCell>
              <TableCell>{formatAmount(order.skuTotalAmount)}</TableCell>
              <TableCell>{formatAmount(order.skuTotalAmount / order.qty)}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Summary</TableCell>
            <TableCell>{totalQty}</TableCell>
            <TableCell>{formatAmount(totalAmount)}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}

export default CompanyOrderDetail